export default __webpack_public_path__ + "static/media/IResponsiveFullSize.6edcff85.png";